// Tracks the height of mobile browser chrome (iOS Safari bottom toolbar /
// Android Chrome address bar) currently overlapping the layout viewport.
//
// position: fixed elements anchor to the *layout* viewport, which extends
// behind the browser's chrome — so a `bottom: 0` element disappears under
// the URL bar / toolbar when chrome shows. visualViewport reports the
// visible portion; the delta tells us how far to shift fixed elements up.
//
// Returns 0 when no chrome overlap (or when running where visualViewport
// is unavailable, e.g. older Safari, SSR). Listens to both `resize` and
// `scroll` since iOS fires the latter when toolbars reveal mid-scroll.

import { useEffect, useState } from 'react';

export default function useChromeOffset() {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.visualViewport) return undefined;
    const vv = window.visualViewport;
    const update = () => {
      const o = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      setOffset(o);
    };
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    update();
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);
  return offset;
}
